export default __webpack_public_path__ + "static/media/2018 (4).a799cd6a.jpg";